import Box from '@material-ui/core/Box'
import React from 'react'
import styled from 'styled-components'
import {DEFAULT_FOOTER_IMAGE_SIZE} from 'Event/template/Townhall/Dashboard/Footer/FooterConfig'
import {useTownhallTemplate} from 'Event/template/Townhall'

export default function Image() {
  const template = useTownhallTemplate()
  const {footer} = template

  if (!footer.image) {
    return null
  }

  return (
    <Box mb={4}>
      <StyledImage
        src={footer.image}
        aria-label="footer image"
        width={footer.imageSize || DEFAULT_FOOTER_IMAGE_SIZE}
      />
    </Box>
  )
}

const StyledImage = styled.img<{width: number}>`
  width: ${(props) => props.width}px;
  max-width: 100%;
`
